export default __webpack_public_path__ + "static/media/saskatchewan research council.c4de9b0e.svg";